module.exports = __webpack_public_path__ + "static/img/effectbannerbg2.5f8515c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/effectbannerbg2.png
// module id = md3N
// module chunks = 171